import { Component } from '@angular/core';

@Component({
  selector: 'app-hero-dashboard',
  standalone: true,
  templateUrl: './hero-dashboard.component.html',
  styleUrls: ['./hero-dashboard.component.css']
})
export class HeroDashboardComponent {}